import { render, staticRenderFns } from "./VoidNsf.vue?vue&type=template&id=7dcc231c&scoped=true"
import script from "./VoidNsf.vue?vue&type=script&lang=js"
export * from "./VoidNsf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dcc231c",
  null
  
)

export default component.exports